/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Name_LabelInputs */

const th_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อ`)
};

const en_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const ja_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称`)
};

const zh_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称`)
};

const es_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const pt_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const id_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

const fr_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const tl_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangalan`)
};

const vi_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên`)
};

const ko_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름`)
};

const de_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const ru_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название`)
};

const tr_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad`)
};

const it_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const pl_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa`)
};

const uk_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва`)
};

const hi_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम`)
};

const ar_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسم`)
};

const ms_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

const bn_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নাম`)
};

const zh_tw2_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名稱`)
};

const zh_hk2_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名稱`)
};

const ur_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام`)
};

const fa_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام`)
};

const sw_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina`)
};

const nl_event_name_label = /** @type {(inputs: Event_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Event_Name_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_name_label = /** @type {((inputs?: Event_Name_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Name_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_name_label(inputs)
	if (locale === "ja") return ja_event_name_label(inputs)
	if (locale === "zh") return zh_event_name_label(inputs)
	if (locale === "es") return es_event_name_label(inputs)
	if (locale === "pt") return pt_event_name_label(inputs)
	if (locale === "id") return id_event_name_label(inputs)
	if (locale === "fr") return fr_event_name_label(inputs)
	if (locale === "tl") return tl_event_name_label(inputs)
	if (locale === "vi") return vi_event_name_label(inputs)
	if (locale === "ko") return ko_event_name_label(inputs)
	if (locale === "de") return de_event_name_label(inputs)
	if (locale === "ru") return ru_event_name_label(inputs)
	if (locale === "tr") return tr_event_name_label(inputs)
	if (locale === "it") return it_event_name_label(inputs)
	if (locale === "pl") return pl_event_name_label(inputs)
	if (locale === "uk") return uk_event_name_label(inputs)
	if (locale === "hi") return hi_event_name_label(inputs)
	if (locale === "ar") return ar_event_name_label(inputs)
	if (locale === "ms") return ms_event_name_label(inputs)
	if (locale === "bn") return bn_event_name_label(inputs)
	if (locale === "zh-TW") return zh_tw2_event_name_label(inputs)
	if (locale === "zh-HK") return zh_hk2_event_name_label(inputs)
	if (locale === "ur") return ur_event_name_label(inputs)
	if (locale === "fa") return fa_event_name_label(inputs)
	if (locale === "sw") return sw_event_name_label(inputs)
	if (locale === "nl") return nl_event_name_label(inputs)
	return en_event_name_label(inputs)
});